import React from "react";
import { banner_rgt, ios_img, playstore_img } from "../../assets";
import Header from "../../Components/header/Header";
import "../landingpage/NewHome.css";
import { TiArrowRight } from "react-icons/ti";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import Accordion from "react-bootstrap/Accordion";
import Footer from "./section/Footer";
import NewFaqHome from "./section/NewFaqHome";
import LoginLandingPage from "./section/LoginLandingPage";

const NewHome = () => {
  return (
    <div id="home">
      <Header />

      <div className="newhome_parent">
        <div className="newhome_child">
          <div className="custom_container">
            <div className="banner_section">
              <div className="banner_content_lft">
                <h1>Logical Chat</h1>
                <p>
                  Discover a social media platform designed for meaningful
                  connections and conversations between passionate people!
                </p>
              </div>

              <div className="banner_content_rgt">
                <img src={banner_rgt} alt="banner_img" />
              </div>
            </div>
            {/* -----------login----------- */}
            <LoginLandingPage />

          </div>

          <div className="download_now">
            <div className="custom_container">
              <div className="background_color">
                <p>Journey to Brilliance: your Ultimate on demand </p>
                <h3>Download the App Now!</h3>

                <div className="mobile_logo">
                  <a href="#">
                    <img src={playstore_img} alt="playstore" />
                  </a>
                  <a href="#">
                    <img src={ios_img} alt="ios" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="faq_section" id="faq">
            <div className="custom_container">
              <h3>Frequently Asked Questions</h3>
              <NewFaqHome />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NewHome;
